import { create } from 'zustand';
import api from '../utils/api';

const useAuthStore = create((set, get) => ({
  user: null,
  isAuthenticated: false,
  isLoading: false,
  error: null,

  // 初始化
  init: () => {
    const token = localStorage.getItem('token');
    const savedUser = localStorage.getItem('user');
    if (token && savedUser) {
      set({ user: JSON.parse(savedUser), isAuthenticated: true });
      get().fetchProfile();
    }
  },

  // 获取用户信息
  fetchProfile: async () => {
    try {
      const data = await api.get('/auth/me');
      if (data.success) {
        set({ user: data.user });
        localStorage.setItem('user', JSON.stringify(data.user));
      }
    } catch (error) {
      console.error('获取用户信息失败:', error);
    }
  },

  // 登录
  login: async (email, password) => {
    set({ isLoading: true, error: null });
    try {
      const deviceId = localStorage.getItem('deviceId') || crypto.randomUUID();
      const data = await api.post('/auth/login', { email, password, deviceId });
      if (data.success) {
        localStorage.setItem('token', data.token);
        localStorage.setItem('deviceId', data.deviceId);
        localStorage.setItem('user', JSON.stringify(data.user));
        set({ user: data.user, isAuthenticated: true, isLoading: false });
        return { success: true };
      }
    } catch (error) {
      set({ error: error.message || '登录失败', isLoading: false });
      return { success: false, error: error.message };
    }
  },

  // 注册
  register: async (userData) => {
    set({ isLoading: true, error: null });
    try {
      const data = await api.post('/auth/register', userData);
      if (data.success) {
        localStorage.setItem('token', data.token);
        localStorage.setItem('deviceId', data.deviceId);
        localStorage.setItem('user', JSON.stringify(data.user));
        set({ user: data.user, isAuthenticated: true, isLoading: false });
        return { success: true };
      }
    } catch (error) {
      set({ error: error.message || '注册失败', isLoading: false });
      return { success: false, error: error.message };
    }
  },

  // 登出
  logout: () => {
    localStorage.removeItem('token');
    localStorage.removeItem('deviceId');
    localStorage.removeItem('user');
    set({ user: null, isAuthenticated: false });
  },

  // 更新用户信息
  updateProfile: async (profileData) => {
    try {
      const data = await api.put('/auth/profile', profileData);
      if (data.success) {
        set({ user: { ...get().user, ...data.user } });
        localStorage.setItem('user', JSON.stringify({ ...get().user, ...data.user }));
        return { success: true };
      }
    } catch (error) {
      return { success: false, error: error.message };
    }
  },

  // 清除错误
  clearError: () => set({ error: null })
}));

export default useAuthStore;
